import { useState } from 'react'
import Modal from '../ui/Modal.jsx'
import { apiFetch } from '../../lib/api.js'

export default function KahootImportModal({ open, deckId, onClose, onImported }) {
  const [urls, setUrls] = useState([''])
  const [importImages, setImportImages] = useState(true)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [result, setResult] = useState(null)

  function handleUrlChange(i, val) {
    const next = [...urls]
    next[i] = val
    if (i === next.length - 1 && val.trim()) next.push('')
    setUrls(next)
    setError('')
  }

  async function handleSubmit(e) {
    e.preventDefault()
    const validUrls = urls.filter(u => u.trim())
    if (validUrls.length === 0) {
      setError('Renseignez au moins une URL Kahoot')
      return
    }
    setLoading(true)
    setError('')
    try {
      const data = await apiFetch(`/api/decks/${deckId}/import/kahoot`, {
        method: 'POST',
        body: JSON.stringify({ urls: validUrls, importImages }),
      })
      setResult(data)
      onImported?.()
    } catch (e) {
      setError(e.message)
    }
    setLoading(false)
  }

  function handleClose() {
    setUrls([''])
    setImportImages(true)
    setError('')
    setResult(null)
    onClose()
  }

  return (
    <Modal open={open} onClose={handleClose} title="📥 Importer depuis Kahoot" maxWidth="max-w-lg">
      {result ? (
        <div className="text-center py-4">
          <div className="text-5xl mb-4">✅</div>
          <p className="text-white font-semibold text-lg mb-2">Import terminé</p>
          <p className="text-white/60 mb-6">
            {result.imported} question{result.imported !== 1 ? 's' : ''} importée{result.imported !== 1 ? 's' : ''}
            {result.skipped > 0 ? `, ${result.skipped} ignorée${result.skipped !== 1 ? 's' : ''} (format incompatible ou quiz privé)` : ''}
          </p>
          <p className="text-white/40 text-xs mb-6">Les questions ont été placées dans le sous-thème « Général ».</p>
          <button onClick={handleClose} className="btn-primary px-8 py-2">Fermer</button>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            {urls.map((url, i) => (
              <input
                key={i}
                type="url"
                value={url}
                onChange={e => handleUrlChange(i, e.target.value)}
                placeholder="https://create.kahoot.it/details/..."
                className="w-full bg-white/10 border border-white/20 rounded-lg px-3 py-2 text-white placeholder-white/30 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            ))}
          </div>

          {error && <p className="text-red-400 text-sm">{error}</p>}

          <div className="flex items-center justify-between py-1">
            <div>
              <p className="text-sm font-medium text-white/80">Import des questions avec images</p>
              <p className="text-xs text-white/40">
                {importImages
                  ? 'Les questions Kahoot avec images sont importées'
                  : 'Les questions Kahoot avec images ne sont pas importées'}
              </p>
            </div>
            <button
              type="button"
              role="switch"
              aria-checked={importImages}
              onClick={() => setImportImages(v => !v)}
              className={`relative inline-flex h-7 w-12 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors ${
                importImages ? 'bg-blue-500' : 'bg-white/20'
              }`}
            >
              <span className={`inline-block h-6 w-6 rounded-full bg-white shadow transition-transform ${
                importImages ? 'translate-x-5' : 'translate-x-0'
              }`} />
            </button>
          </div>

          <div className="flex gap-3 justify-end pt-2">
            <button type="button" onClick={handleClose} className="px-4 py-2 text-white/60 hover:text-white transition">
              Annuler
            </button>
            <button type="submit" disabled={loading} className="btn-primary px-6 py-2 disabled:opacity-60">
              {loading ? 'Import en cours…' : 'Importer'}
            </button>
          </div>
        </form>
      )}
    </Modal>
  )
}
